import * as React from 'react';
import { SupplierDirectoryType, User } from '@ordermentum/ui-types';
import { connect } from 'react-redux';
import styled from '@emotion/styled';
import { MEDIA_QUERIES as M } from '../../foundations/grid';
import SupplierInformation from './components/SupplierInformation';
import { FUTURO as Colors } from '../../foundations/color';
import Header from './components/Header';
import { logoutAsync } from './utilities/auth';

type Props = {
  params: { supplierId: string; retailerId?: string };
  supplier: SupplierDirectoryType | undefined;
  children: React.ReactNode;
  sticky?: boolean;
  showSupplierInformation?: boolean;
  signedIn?: boolean;

  user: User;
  logout: (...args) => void;
};

const Wrapper = styled.div({
  backgroundColor: Colors.LIGHT.SWAN,
  width: '100%',
  height: 'calc(100vh - 4.5rem)',
  [M.TABLET_PORTRAIT_AND_SMALLER]: {
    height: 'auto',
  },
});

const Content = styled.div({
  display: 'grid',
  gridTemplateColumns: 'repeat(2, 1fr)',
  height: '100%',
  [M.TABLET_PORTRAIT_AND_SMALLER]: {
    gridTemplateColumns: '100%',
    minHeight: 0,
  },
});

const SignupFlowTemplate = (props: Props) => {
  const {
    params,
    supplier,
    children,
    sticky = false,
    user,
    logout,
    showSupplierInformation,
    signedIn,
  } = props;

  return (
    <Wrapper>
      <Header sticky={sticky} params={params} user={user} logout={logout} />
      <Content>
        {supplier && (
          <>
            <SupplierInformation
              supplier={supplier}
              showInformation={showSupplierInformation}
              signedIn={signedIn}
            />

            {children}
          </>
        )}
      </Content>
    </Wrapper>
  );
};

const mapStateToProps = (state: any) => ({
  user: state.profile?.data ?? state.user.get('data').toJS(),
  flags: state.flags?.data ?? {},
});

const mapDispatchToProps = {
  logout: logoutAsync,
};

export default connect(mapStateToProps, mapDispatchToProps)(SignupFlowTemplate);
